import script from "./TradingDeskView.vue?vue&type=script&setup=true&lang=js"
export * from "./TradingDeskView.vue?vue&type=script&setup=true&lang=js"

import "./TradingDeskView.vue?vue&type=style&index=0&id=510eb6e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-510eb6e4"]])

export default __exports__